var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "width": "1200px",
      "title": "Status Track",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('el-descriptions', {
    attrs: {
      "column": 3,
      "size": "medium",
      "border": "",
      "labelStyle": {
        width: '120px'
      }
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "contentStyle": {
        width: '90px'
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Quotation (V)")]), _vm._v(" " + _vm._s(_vm.detailInfo.adjustmentNo || "") + " ")]), _c('el-descriptions-item', {
    attrs: {
      "contentStyle": {
        width: '90px'
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Trans No.")]), _vm._v(" " + _vm._s(_vm.detailInfo.applymentNo || "") + " ")]), _c('el-descriptions-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Billing Party")]), _vm._v(" " + _vm._s(_vm.detailInfo.billingParty || "") + " ")])], 1), _c('div', {
    staticClass: "pt14"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "align": "center",
      "label": "Handling Time",
      "width": "164"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("parseTimeSecond")(scope.row.createAt)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Status",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.adjustmentStatusFormat(scope.row.adjustmentStatus)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "label": "Description / Remark",
      "min-width": "120"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "userInfo",
      "align": "center",
      "label": "Handler",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userInfo.nickname))])];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }